const QUERY_KEYS = {
  USER: ['user'],
  REPORTS: {
    LIST: ['listReports'],
    DETAIL: (id: string) => ['report', id],
  },
  WALLET: ['wallet'],
  PLANS: {
    ALL: ['plans'],
    WITH_CURRENCY: (currency: string, language: string) => [
      'plansWithLocalCurrency',
      currency,
      language,
    ],
  },
  GEOLOCATION: ['get-geo-location'],
  CURRENCY_CONVERSION: (from: string, to: string, amount?: number) => [
    'currencyConversion',
    from,
    to,
    amount,
  ],
};

export default QUERY_KEYS;
